<template>
    <v-sheet>
        <v-row justify="end" class="row--small">
            <v-col cols="12" lg="auto">
                <v-select v-model="searchKey" :items="searchKeys" outlined hide-details="auto" class="w-lg-100px"></v-select>
            </v-col>
            <v-col cols="" lg="auto">
                <v-text-field v-model="searchValue" outlined hide-details="auto" class="w-lg-240px"></v-text-field>
            </v-col>
            <v-col cols="auto" lg="auto">
                <v-btn color="grey" class="white--text" small @click="$emit('search', { searchKey, searchValue })">Search</v-btn>
            </v-col>
        </v-row>

        <v-divider class="board-divider" />

        <v-row>
            <template v-for="board in boards">
                <v-col cols="6" md="3" :key="board._id">
                    <v-card tile flat @click="$emit('click', board)">
                        <v-img :src="board.thumb">
                            <v-responsive :aspect-ratio="1 / 1" />
                        </v-img>
                        <v-card-title class="ellip">{{ board.subject }}</v-card-title>
                        <v-card-text>{{ board.createdAt.toDate() }}</v-card-text>
                    </v-card>
                </v-col>
            </template>
        </v-row>

        <slot name="pagination"></slot>
    </v-sheet>
</template>

<script>

export default {
    props: {
        code: { type: String, default: null },
        summary: {
            type: Object,
            default() {
                return { totalCount: 0 };
            },
        },
        boards: { type: Array, default: null },
        notices: { type: Array, default: null },
        page: { type: Number, default: 1 },
        skip: { type: Number, default: 0 },
        limit: { type: Number, default: null },
    },
    data() {
        return {
            searchKeys: [
                { text: "subject", value: "subject" },
                { text: "subject + content", value: "subjectcontent" },
            ],
            searchKey: null,
            searchValue: null,
        }
    }
};
</script>

<style lang="scss" scoped>
// 검색 버튼
.v-btn {
    padding: 0 18px !important;
}

// board-divider
.board-divider {
    border-color: var(--v-grey-darken4);
    border-width: 1px;
    margin: 16px 0 28px;
}
@media (min-width: 1024px) {
    .board-divider {
        margin: 20px 0 32px;
    }
}

// 게시판 카드
.v-card {
    padding-bottom: 32px;
    &__title {
        padding: 18px 0 0;
    }
    &__text {
        padding: 6px 0 0 !important;
    }
}
@media (min-width: 1024px) {
    .v-card {
        padding-bottom: 48px;
        &__title {
            padding: 24px 0 0;
        }
        &__text {
            padding: 8px 0 0 !important;
        }
    }
}
</style>